<template>
  <div class="d-inline-flex justify-content-around status-indicator" :class="[ getBackgroundClass(value), { 'full-width': fullWidth } ]">
    <div v-if="value !== null && value !== undefined" class="status-indicator-cell">
      {{ value | formatNumber(precision) }}
    </div>
    <div v-else class="status-indicator-cell">
      -
    </div>
    <div v-if="value" class="status-indicator-cell">
      <i v-if="iconClass" :class="iconClass"/>
    </div>
  </div>
</template>

<script>
  import { getBackgroundClass } from '../../../util/colors'

  export default {
    name: 'StatusIndicator',
    props: {
      value: {
        type: Number
      },
      precision: {
        type: Number,
        default: () => 0
      },
      trend: {
        type: Number
      },
      fullWidth: {
        type: Boolean
      }
    },
    computed: {
      iconClass: function () {
        if (this.trend === undefined) {
          return ''
        }
        return this.trend > 0 ? 'fa fa-arrow-up' : (this.trend < 0 ? 'fa fa-arrow-down' : 'fa fa-equals')
      }
    },
    methods: {
      getBackgroundClass
    }
  }
</script>

<style lang="scss" scoped>
  .status-indicator {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    display: inline-block;
    min-width: 72px;
    max-width: 72px;
    height: 40px;
    line-height: 40px;
    margin: 1px 1px;
    border-radius: 30px;
    padding: 0 15px;
    &.full-width {
      width: 100%;
    }
    &-cell {
      display: inline-block;
      padding: 0 4px;
      color: black;
      text-align: center;
    }
    :last-child {
      text-align: left;
    }
  }
</style>
